





















import firebase from 'firebase/app'
import router from 'vue-router'
import {
  getModule,
} from 'vuex-module-decorators'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import MainMixin from '../../mixins/MainMixin'
import MessageWrapper from '../messages/MessageWrapper.vue'
import MessageStore from '../../store/modules/messages'
import TaskWrapper from '../tasks/TaskWrapper.vue'
import TaskStore from '../../store/modules/tasks'

@Component({
  components: {
    MessageWrapper,
    TaskWrapper,
  },
})

export default class QuickBar extends Mixins(MainMixin) {
  Messages = getModule(MessageStore) as any

  Tasks = getModule(TaskStore) as any

  async created() {
    const results = await Promise.all([this.Messages.bindMessages(), this.Tasks.bindTasks()])
    console.log('results for the quickbar: ', results)
  }
}
